// Code generated using graphql-codegen - DO NOT EDIT.
/*eslint-disable*/
import type * as Types from './types';

import type { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
export const AddressFragmentDoc = /*#__PURE__*/ gql`
    fragment Address on addresses {
  addressable_id
  addressable_type
  attention_to
  city
  id
  state
  street_1
  street_2
  zipcode
}
    `;
export const NeedStatusFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment NeedStatusFragment on needs {
  is_met_by_current_user
  state
  completed_at
  checkout_intent {
    id
    updated_at
  }
  checkout_intents {
    id
    updated_at
  }
}
    `;
export const OrganizationFragmentDoc = /*#__PURE__*/ gql`
    fragment Organization on organizations {
  id
  alias
  v_alias
  name
  list_id
  created_at
  updated_at
  description
  url
  profile_image_path
  hero_image_path
  latitude
  longitude
  inactive
  private
  parent_organization_id
  data
  stats {
    needs_available_count
    follower_count
  }
  location {
    city
    state
  }
  tags: data(path: "tags")
  give_now: data(path: "give_now_enabled")
  auto_join_team: data(path: "auto_join_team")
}
    `;
export const OrganizationPreviewFragmentDoc = /*#__PURE__*/ gql`
    fragment OrganizationPreview on organizations {
  id
  alias
  v_alias
  name
  profile_image_path
  stats {
    needs_available_count
  }
}
    `;
export const TeamPreviewFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamPreview on teams {
  id
  alias
  v_alias
  name
  profile_picture_path
  needs_stats {
    count
  }
}
    `;
export const TeamAvatarFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamAvatar on team_avatars {
  membership_id
  user_avatar_path
}
    `;
export const TeamDetailFragmentDoc = /*#__PURE__*/ gql`
    fragment TeamDetail on teams {
  id
  name
  alias
  v_alias
  subheading
  profile_picture_path
  query_tags: data(path: "needs_query.organization.tags")
  need_tags: data(path: "needs_query.need.tags")
  avatars {
    ...TeamAvatar
  }
  stats {
    members_count
  }
  needs_stats {
    count
    sum
  }
  give_now: data(path: "give_now_enabled")
}
    ${TeamAvatarFragmentDoc}`;
export const NeedCardFragmentDoc = /*#__PURE__*/ gql`
    fragment NeedCard on needs {
  id
  title
  short_description
  price_including_sales_tax
  location {
    city
    state
    latitude
    longitude
  }
  organization {
    id
    alias
    v_alias
    name
    profile_image_path
  }
}
    `;
export const NeedsMetFragmentDoc = /*#__PURE__*/ gql`
    fragment NeedsMet on teams {
  needs_met(order_by: {needs: {completed_at: desc_nulls_last}}, limit: 10) {
    need: needs {
      ...NeedCard
    }
  }
}
    ${NeedCardFragmentDoc}`;
export const NeedFragmentDoc = /*#__PURE__*/ gql`
    fragment Need on needs {
  id: id_canonical
  short_description
  full_description
  price_including_sales_tax
  title
  state
  location {
    city
    state
    latitude
    longitude
  }
  rank_distance
  need_information {
    direct_checkout_description: notes
    picture_path
  }
  direct_checkout
  organization {
    id: id_canonical
    alias
    v_alias
    name
    latitude
    longitude
    profile_image_path
  }
  list {
    sponsorships {
      sponsor {
        id: id_canonical
        name
        link
        primary
        abbreviated_name
        logo_path
      }
    }
  }
  updated_at
  completed_at
  is_met_by_current_user
  checkout_intent {
    id
  }
  thank_yous {
    id
    body
    picture_path
  }
  data
  need_tags {
    tag
  }
  has_tags
  tags: data(path: "tags")
  tax_exempt: data(path: "tax_exempt")
  private
}
    `;
export const UserProfileFragmentDoc = /*#__PURE__*/ gql`
    fragment UserProfile on users {
  id
  first_name
  last_name
  username
  avatar_path
  email
  stats {
    year
    count
  }
  goal {
    target_value
    goal_period
  }
  is_public: profile_public
  needs_met(
    order_by: {completed_at: desc_nulls_last}
    offset: $offset
    limit: $limit
  ) {
    ...Need
  }
  needs_met_stats {
    all_time
    this_year
    this_month
    all_time_value
  }
}
    ${NeedFragmentDoc}`;
export const AddressesDocument = /*#__PURE__*/ gql`
    query addresses($cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  addresses {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const AddressDocument = /*#__PURE__*/ gql`
    query address($addressId: Int!, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  address: addresses_by_pk(id: $addressId) {
    ...Address
  }
}
    ${AddressFragmentDoc}`;
export const NeedIdsQueryDocument = /*#__PURE__*/ gql`
    query NeedIdsQuery($count: Int! = 10, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  needs(
    where: {state: {_eq: "published"}}
    limit: $count
    order_by: {updated_at: desc}
  ) {
    id
  }
}
    `;
export const AliasesDocument = /*#__PURE__*/ gql`
    query Aliases {
  organization: organizations(order_by: {id: asc}) {
    id
    alias
    v_alias
  }
  team: teams(order_by: {id: asc}) {
    id
    alias
    v_alias
  }
}
    `;
export const ListsDocument = /*#__PURE__*/ gql`
    query lists($cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  lists(
    order_by: [{state_code: asc}, {is_state: desc}, {name: asc}]
    where: {is_team: {_eq: false}, active: {_eq: true}}
  ) {
    id
    slug
    name
    state_code
    is_state
  }
}
    `;
export const ListDocument = /*#__PURE__*/ gql`
    query list($listId: Int!, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  list: lists_by_pk(id: $listId) {
    id
    slug
    name
    state_code
    about
    active
    is_state
    is_team
  }
}
    `;
export const NeedDocument = /*#__PURE__*/ gql`
    query need($needId: Int!, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  need: needs_by_pk(id: $needId) {
    ...Need
  }
}
    ${NeedFragmentDoc}`;
export const NeedStatusDocument = /*#__PURE__*/ gql`
    query needStatus($needId: Int!, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  status: needs_by_pk(id: $needId) {
    ...NeedStatusFragment
  }
}
    ${NeedStatusFragmentFragmentDoc}`;
export const NeedStatusLiveDocument = /*#__PURE__*/ gql`
    subscription needStatusLive($needId: Int!) {
  status: needs_by_pk(id: $needId) {
    ...NeedStatusFragment
  }
}
    ${NeedStatusFragmentFragmentDoc}`;
export const NeedsDocument = /*#__PURE__*/ gql`
    query needs($where: needs_bool_exp = {}, $order_by: [needs_order_by!] = {id: asc}, $limit: Int = 25, $offset: Int = 0, $distinct_on: [needs_select_column!], $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  needs(
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...Need
  }
}
    ${NeedFragmentDoc}`;
export const NeedsGeoDocument = /*#__PURE__*/ gql`
    query needsGeo($where: needs_bool_exp = {}, $order_by: [needs_order_by!] = {id: asc}, $limit: Int = 25, $offset: Int = 0, $distinct_on: [needs_select_column!], $latitude: float8, $longitude: float8, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  needs: needs_geo(
    args: {latitude: $latitude, longitude: $longitude}
    where: $where
    order_by: $order_by
    offset: $offset
    limit: $limit
    distinct_on: $distinct_on
  ) {
    ...Need
  }
}
    ${NeedFragmentDoc}`;
export const OrganizationDocument = /*#__PURE__*/ gql`
    query organization($orgId: Int!, $withStats: Boolean = true, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  organization: organizations_by_pk(id: $orgId) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export const OrganizationByAliasDocument = /*#__PURE__*/ gql`
    query organizationByAlias($v_alias: String!, $withStats: Boolean = true, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  organization: organizations(limit: 1, where: {v_alias: {_eq: $v_alias}}) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export const OrganizationsPreviewDocument = /*#__PURE__*/ gql`
    query organizationsPreview($filter: organizations_bool_exp = {_and: {inactive: {_eq: false}, private: {_eq: false}}}, $order_by: [organizations_order_by!] = {name: asc}, $limit: Int, $offset: Int, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  organizations(
    where: $filter
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...OrganizationPreview
  }
}
    ${OrganizationPreviewFragmentDoc}`;
export const OrganizationsDocument = /*#__PURE__*/ gql`
    query organizations($filter: organizations_bool_exp = {_and: {inactive: {_eq: false}, private: {_eq: false}}}, $order_by: [organizations_order_by!] = {name: asc}, $limit: Int, $offset: Int, $withStats: Boolean = true, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  organizations(
    where: $filter
    order_by: $order_by
    offset: $offset
    limit: $limit
  ) {
    ...Organization
  }
}
    ${OrganizationFragmentDoc}`;
export const OrganizationNeedsDocument = /*#__PURE__*/ gql`
    query organizationNeeds($orgId: Int!, $filter: needs_bool_exp = {}, $order_by: [needs_order_by!] = {id: asc}, $limit: Int, $offset: Int, $withStats: Boolean = true, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  organization: organizations_by_pk(id: $orgId) {
    ...Organization
    needs(where: $filter, order_by: $order_by, offset: $offset, limit: $limit) {
      id
    }
  }
}
    ${OrganizationFragmentDoc}`;
export const NeedsByOrgDocument = /*#__PURE__*/ gql`
    query needsByOrg($orgId: Int!, $filter: needs_bool_exp = {state: {_in: ["published"]}}, $order_by: [needs_order_by!] = {updated_at: desc}, $limit: Int = 20, $offset: Int = 0, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  organization: organizations_by_pk(id: $orgId) {
    needs(where: $filter, order_by: $order_by, limit: $limit, offset: $offset) {
      ...Need
    }
  }
}
    ${NeedFragmentDoc}`;
export const NeedsByOrgAliasDocument = /*#__PURE__*/ gql`
    query needsByOrgAlias($v_alias: String!, $filter: needs_bool_exp = {state: {_in: ["published"]}}, $order_by: [needs_order_by!] = {updated_at: desc}, $limit: Int = 20, $offset: Int = 0, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  organization: organizations(limit: 1, where: {v_alias: {_eq: $v_alias}}) {
    needs(where: $filter, order_by: $order_by, limit: $limit, offset: $offset) {
      ...Need
    }
  }
}
    ${NeedFragmentDoc}`;
export const StoriesDocument = /*#__PURE__*/ gql`
    query stories($filter: stories_bool_exp = {}, $order_by: [stories_order_by!] = {id: desc}, $limit: Int = 25, $offset: Int = 0, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  stories(where: $filter, order_by: $order_by, offset: $offset, limit: $limit) {
    body
    created_at
    hero_image_content_type
    hero_image_file_name
    hero_image_file_size
    hero_image_path
    hero_image_updated_at
    id
    published_date
    title
    updated_at
  }
}
    `;
export const StoryDocument = /*#__PURE__*/ gql`
    query story($storyId: Int!, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  story: stories_by_pk(id: $storyId) {
    body
    created_at
    hero_image_content_type
    hero_image_file_name
    hero_image_file_size
    hero_image_path
    hero_image_updated_at
    id
    published_date
    title
    updated_at
  }
}
    `;
export const TeamsDocument = /*#__PURE__*/ gql`
    query teams($filter: teams_bool_exp = {private: {_eq: false}}, $order_by: [teams_order_by!] = {name: asc}, $limit: Int = 100, $offset: Int = 0, $includeConnection: Boolean! = false, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  teams(where: $filter, order_by: $order_by, offset: $offset, limit: $limit) {
    ...TeamPreview
    is_member @include(if: $includeConnection)
  }
}
    ${TeamPreviewFragmentDoc}`;
export const TeamDetailsDocument = /*#__PURE__*/ gql`
    query teamDetails($teamId: Int!, $withNeedsMet: Boolean! = false, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  team: teams_by_pk(id: $teamId) {
    ...TeamDetail
    ...NeedsMet @include(if: $withNeedsMet)
  }
}
    ${TeamDetailFragmentDoc}
${NeedsMetFragmentDoc}`;
export const TeamDetailsByAliasDocument = /*#__PURE__*/ gql`
    query teamDetailsByAlias($v_alias: String!, $withNeedsMet: Boolean! = false, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  team: teams(limit: 1, where: {v_alias: {_eq: $v_alias}}) {
    ...TeamDetail
    ...NeedsMet @include(if: $withNeedsMet)
  }
}
    ${TeamDetailFragmentDoc}
${NeedsMetFragmentDoc}`;
export const _CreateCheckoutSessionDocument = /*#__PURE__*/ gql`
    mutation _createCheckoutSession($need_ids: [Int!]!) {
  session: create_checkout_session(need_ids: $need_ids, tip_percentage: 0.15) {
    checkout_session_id
    checkout_url
    transaction {
      line_items {
        type
        id
        amount
        metadata
      }
      summary {
        count
        sum
      }
    }
  }
}
    `;
export const _ExpireCheckoutSessionDocument = /*#__PURE__*/ gql`
    mutation _expireCheckoutSession($checkout_session_id: String!) {
  session: expire_checkout_session(checkout_session_id: $checkout_session_id) {
    checkout_session_id
  }
}
    `;
export const UserConnectionsDocument = /*#__PURE__*/ gql`
    query userConnections($cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  me {
    teams: team_memberships(order_by: {updated_at: desc}) {
      team {
        id
        alias
        v_alias
      }
    }
    orgs: organization_subscriptions(order_by: {updated_at: desc}) {
      org: organization {
        id
        alias
        v_alias
      }
    }
    lists: list_subscriptions(order_by: {updated_at: desc}) {
      list {
        id
      }
    }
  }
}
    `;
export const JoinTeamDocument = /*#__PURE__*/ gql`
    mutation joinTeam($teamId: Int!) {
  insert_team_memberships_one(object: {team_id: $teamId}) {
    team_id
  }
}
    `;
export const LeaveTeamDocument = /*#__PURE__*/ gql`
    mutation leaveTeam($teamId: Int!) {
  delete_team_memberships(where: {team_id: {_eq: $teamId}}) {
    affected_rows
    returning {
      team_id
    }
  }
}
    `;
export const FollowOrganizationDocument = /*#__PURE__*/ gql`
    mutation followOrganization($orgId: Int!) {
  insert_organization_subscriptions_one(object: {organization_id: $orgId}) {
    id
    created_at
    updated_at
    organization_id
    user_id
  }
}
    `;
export const UnfollowOrganizationDocument = /*#__PURE__*/ gql`
    mutation unfollowOrganization($orgId: Int!) {
  delete_organization_subscriptions(where: {organization_id: {_eq: $orgId}}) {
    returning {
      id
    }
  }
}
    `;
export const SubscribeToListDocument = /*#__PURE__*/ gql`
    mutation subscribeToList($listId: Int!) {
  insert_list_subscriptions_one(object: {list_id: $listId}) {
    id
    created_at
    updated_at
    list_id
    user_id
  }
}
    `;
export const UnsubscribeToListDocument = /*#__PURE__*/ gql`
    mutation unsubscribeToList($listId: Int!) {
  delete_list_subscriptions(where: {list_id: {_eq: $listId}}) {
    returning {
      id
    }
  }
}
    `;
export const ExchangeLegacyTokenDocument = /*#__PURE__*/ gql`
    mutation exchangeLegacyToken($params: ExchangeLegacyTokenParams!) {
  exchange_legacy_token(params: $params) {
    clerk_ticket
  }
}
    `;
export const FeedItemsDocument = /*#__PURE__*/ gql`
    query feedItems($cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  feed_items {
    created_at
    feedable_id
    feedable_type
    id
    state
    updated_at
    user_id
  }
}
    `;
export const FeedItemDocument = /*#__PURE__*/ gql`
    query feedItem($feedItemId: Int!, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  feed_item: feed_items_by_pk(id: $feedItemId) {
    created_at
    feedable_id
    feedable_type
    id
    state
    updated_at
    user_id
  }
}
    `;
export const FeedPostsDocument = /*#__PURE__*/ gql`
    query feedPosts($cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  feed_posts {
    content
    created_at
    id
    list_ids
    notification_type
    provider_job_id
    send_at
    story_id
    title
    type_label
    updated_at
  }
}
    `;
export const FeedPostDocument = /*#__PURE__*/ gql`
    query feedPost($feedPostId: Int!, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  feed_post: feed_posts_by_pk(id: $feedPostId) {
    content
    created_at
    id
    list_ids
    notification_type
    provider_job_id
    send_at
    story_id
    title
    type_label
    updated_at
  }
}
    `;
export const PostsDocument = /*#__PURE__*/ gql`
    query posts($cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  posts {
    content
    created_at
    id
    title
    updated_at
  }
}
    `;
export const PostDocument = /*#__PURE__*/ gql`
    query post($postId: Int!, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  post: posts_by_pk(id: $postId) {
    content
    created_at
    id
    title
    updated_at
  }
}
    `;
export const GoalsDocument = /*#__PURE__*/ gql`
    query goals($cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  me {
    goal {
      id
      created_at
      updated_at
      goal_period
      target_value
    }
  }
}
    `;
export const UpdateGoalDocument = /*#__PURE__*/ gql`
    mutation updateGoal($number: String!, $regularity: Int!) {
  insert_goals_one(
    object: {number: $number, regularity: $regularity}
    on_conflict: {constraint: goals_goalable_id_goalable_type_type_name_key, update_columns: [number, regularity]}
  ) {
    id
    updated_at
    number
    regularity
  }
}
    `;
export const LegacyAuthTokenDocument = /*#__PURE__*/ gql`
    query LegacyAuthToken {
  current_user {
    legacy_token
  }
}
    `;
export const UserProfileDocument = /*#__PURE__*/ gql`
    query userProfile($offset: Int = 0, $limit: Int = null, $cacheTTL: Int = 1, $cacheRefresh: Boolean = false) @cached(ttl: $cacheTTL, refresh: $cacheRefresh) {
  me {
    ...UserProfile
  }
}
    ${UserProfileFragmentDoc}`;
export const UpdateUserDocument = /*#__PURE__*/ gql`
    mutation updateUser($id: Int!, $updates: users_set_input!) {
  user: update_users_by_pk(pk_columns: {id: $id}, _set: $updates) {
    id
  }
}
    `;
export const RequestLoginTicketDocument = /*#__PURE__*/ gql`
    mutation requestLoginTicket($params: RequestLoginTicketParams!) {
  request_login_ticket(params: $params) {
    login_ticket
  }
}
    `;
export const _CreateUniversalCheckoutDocument = /*#__PURE__*/ gql`
    mutation _createUniversalCheckout($params: CreateUniversalCheckoutParams!) {
  checkout: create_universal_checkout(params: $params) {
    checkout_intent_id
    payment_intent_client_secret
    ephemeral_key_secret
    transaction {
      summary {
        count
        sum
      }
      line_items {
        type
        id
        amount
        metadata
      }
    }
  }
}
    `;
export const _CancelUniversalCheckoutDocument = /*#__PURE__*/ gql`
    mutation _cancelUniversalCheckout($params: CancelUniversalCheckoutParams!) {
  checkout: cancel_universal_checkout(params: $params) {
    checkout_intent_id
    result
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    addresses(variables?: Types.AddressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddressesQuery>(AddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addresses', 'query', variables);
    },
    address(variables: Types.AddressQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AddressQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddressQuery>(AddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'address', 'query', variables);
    },
    NeedIdsQuery(variables?: Types.NeedIdsQueryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.NeedIdsQueryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.NeedIdsQueryQuery>(NeedIdsQueryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'NeedIdsQuery', 'query', variables);
    },
    Aliases(variables?: Types.AliasesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.AliasesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AliasesQuery>(AliasesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Aliases', 'query', variables);
    },
    lists(variables?: Types.ListsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ListsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ListsQuery>(ListsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'lists', 'query', variables);
    },
    list(variables: Types.ListQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ListQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ListQuery>(ListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'list', 'query', variables);
    },
    need(variables: Types.NeedQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.NeedQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.NeedQuery>(NeedDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'need', 'query', variables);
    },
    needStatus(variables: Types.NeedStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.NeedStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.NeedStatusQuery>(NeedStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'needStatus', 'query', variables);
    },
    needStatusLive(variables: Types.NeedStatusLiveSubscriptionVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.NeedStatusLiveSubscription> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.NeedStatusLiveSubscription>(NeedStatusLiveDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'needStatusLive', 'subscription', variables);
    },
    needs(variables?: Types.NeedsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.NeedsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.NeedsQuery>(NeedsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'needs', 'query', variables);
    },
    needsGeo(variables?: Types.NeedsGeoQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.NeedsGeoQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.NeedsGeoQuery>(NeedsGeoDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'needsGeo', 'query', variables);
    },
    organization(variables: Types.OrganizationQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.OrganizationQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OrganizationQuery>(OrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organization', 'query', variables);
    },
    organizationByAlias(variables: Types.OrganizationByAliasQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.OrganizationByAliasQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OrganizationByAliasQuery>(OrganizationByAliasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationByAlias', 'query', variables);
    },
    organizationsPreview(variables?: Types.OrganizationsPreviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.OrganizationsPreviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OrganizationsPreviewQuery>(OrganizationsPreviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationsPreview', 'query', variables);
    },
    organizations(variables?: Types.OrganizationsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.OrganizationsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OrganizationsQuery>(OrganizationsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizations', 'query', variables);
    },
    organizationNeeds(variables: Types.OrganizationNeedsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.OrganizationNeedsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.OrganizationNeedsQuery>(OrganizationNeedsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'organizationNeeds', 'query', variables);
    },
    needsByOrg(variables: Types.NeedsByOrgQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.NeedsByOrgQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.NeedsByOrgQuery>(NeedsByOrgDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'needsByOrg', 'query', variables);
    },
    needsByOrgAlias(variables: Types.NeedsByOrgAliasQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.NeedsByOrgAliasQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.NeedsByOrgAliasQuery>(NeedsByOrgAliasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'needsByOrgAlias', 'query', variables);
    },
    stories(variables?: Types.StoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.StoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.StoriesQuery>(StoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'stories', 'query', variables);
    },
    story(variables: Types.StoryQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.StoryQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.StoryQuery>(StoryDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'story', 'query', variables);
    },
    teams(variables?: Types.TeamsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.TeamsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TeamsQuery>(TeamsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'teams', 'query', variables);
    },
    teamDetails(variables: Types.TeamDetailsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.TeamDetailsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TeamDetailsQuery>(TeamDetailsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'teamDetails', 'query', variables);
    },
    teamDetailsByAlias(variables: Types.TeamDetailsByAliasQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.TeamDetailsByAliasQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.TeamDetailsByAliasQuery>(TeamDetailsByAliasDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'teamDetailsByAlias', 'query', variables);
    },
    _createCheckoutSession(variables: Types._CreateCheckoutSessionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types._CreateCheckoutSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types._CreateCheckoutSessionMutation>(_CreateCheckoutSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), '_createCheckoutSession', 'mutation', variables);
    },
    _expireCheckoutSession(variables: Types._ExpireCheckoutSessionMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types._ExpireCheckoutSessionMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types._ExpireCheckoutSessionMutation>(_ExpireCheckoutSessionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), '_expireCheckoutSession', 'mutation', variables);
    },
    userConnections(variables?: Types.UserConnectionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UserConnectionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UserConnectionsQuery>(UserConnectionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userConnections', 'query', variables);
    },
    joinTeam(variables: Types.JoinTeamMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.JoinTeamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.JoinTeamMutation>(JoinTeamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'joinTeam', 'mutation', variables);
    },
    leaveTeam(variables: Types.LeaveTeamMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.LeaveTeamMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.LeaveTeamMutation>(LeaveTeamDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'leaveTeam', 'mutation', variables);
    },
    followOrganization(variables: Types.FollowOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FollowOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FollowOrganizationMutation>(FollowOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'followOrganization', 'mutation', variables);
    },
    unfollowOrganization(variables: Types.UnfollowOrganizationMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UnfollowOrganizationMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UnfollowOrganizationMutation>(UnfollowOrganizationDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unfollowOrganization', 'mutation', variables);
    },
    subscribeToList(variables: Types.SubscribeToListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.SubscribeToListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SubscribeToListMutation>(SubscribeToListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'subscribeToList', 'mutation', variables);
    },
    unsubscribeToList(variables: Types.UnsubscribeToListMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UnsubscribeToListMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UnsubscribeToListMutation>(UnsubscribeToListDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'unsubscribeToList', 'mutation', variables);
    },
    exchangeLegacyToken(variables: Types.ExchangeLegacyTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.ExchangeLegacyTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ExchangeLegacyTokenMutation>(ExchangeLegacyTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'exchangeLegacyToken', 'mutation', variables);
    },
    feedItems(variables?: Types.FeedItemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FeedItemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FeedItemsQuery>(FeedItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'feedItems', 'query', variables);
    },
    feedItem(variables: Types.FeedItemQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FeedItemQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FeedItemQuery>(FeedItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'feedItem', 'query', variables);
    },
    feedPosts(variables?: Types.FeedPostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FeedPostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FeedPostsQuery>(FeedPostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'feedPosts', 'query', variables);
    },
    feedPost(variables: Types.FeedPostQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.FeedPostQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FeedPostQuery>(FeedPostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'feedPost', 'query', variables);
    },
    posts(variables?: Types.PostsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.PostsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.PostsQuery>(PostsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'posts', 'query', variables);
    },
    post(variables: Types.PostQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.PostQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.PostQuery>(PostDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'post', 'query', variables);
    },
    goals(variables?: Types.GoalsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.GoalsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.GoalsQuery>(GoalsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'goals', 'query', variables);
    },
    updateGoal(variables: Types.UpdateGoalMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateGoalMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateGoalMutation>(UpdateGoalDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateGoal', 'mutation', variables);
    },
    LegacyAuthToken(variables?: Types.LegacyAuthTokenQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.LegacyAuthTokenQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.LegacyAuthTokenQuery>(LegacyAuthTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LegacyAuthToken', 'query', variables);
    },
    userProfile(variables?: Types.UserProfileQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UserProfileQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UserProfileQuery>(UserProfileDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'userProfile', 'query', variables);
    },
    updateUser(variables: Types.UpdateUserMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.UpdateUserMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateUserMutation>(UpdateUserDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateUser', 'mutation', variables);
    },
    requestLoginTicket(variables: Types.RequestLoginTicketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types.RequestLoginTicketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RequestLoginTicketMutation>(RequestLoginTicketDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'requestLoginTicket', 'mutation', variables);
    },
    _createUniversalCheckout(variables: Types._CreateUniversalCheckoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types._CreateUniversalCheckoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types._CreateUniversalCheckoutMutation>(_CreateUniversalCheckoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), '_createUniversalCheckout', 'mutation', variables);
    },
    _cancelUniversalCheckout(variables: Types._CancelUniversalCheckoutMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<Types._CancelUniversalCheckoutMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types._CancelUniversalCheckoutMutation>(_CancelUniversalCheckoutDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), '_cancelUniversalCheckout', 'mutation', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;